import { render } from "./TrimVideo.vue?vue&type=template&id=3bc29aea&scoped=true"
import script from "./TrimVideo.vue?vue&type=script&lang=js"
export * from "./TrimVideo.vue?vue&type=script&lang=js"

import "./TrimVideo.vue?vue&type=style&index=0&id=3bc29aea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc29aea"]])

export default __exports__